/**
 * 都道府県一覧の定義ファイル
 */
export default {
  LOCATION: [
    {
      areaLrgCd: 0,
      name: "北海道・道北",
      list: [
        {
          areaMidCd: "hokkaido",
          name: "北海道",
          num: 1
        },
        {
          areaMidCd: "aomori",
          name: "青森県",
          num: 2
        },
        {
          areaMidCd: "iwate",
          name: "岩手県",
          num: 2
        },
        {
          areaMidCd: "miyagi",
          name: "宮城県",
          num: 2
        },
        {
          areaMidCd: "akita",
          name: "秋田県",
          num: 2
        },
        {
          areaMidCd: "yamagata",
          name: "山形県",
          num: 2
        },
        {
          areaMidCd: "hukushima",
          name: "福島県",
          num: 2
        }
      ]
    },
    {
      areaLrgCd: 1,
      name: "関東",
      list: [
        {
          areaMidCd: "ibaragi",
          name: "茨城県",
          num: 3
        },
        {
          areaMidCd: "tochigi",
          name: "栃木県",
          num: 3
        },
        {
          areaMidCd: "gunma",
          name: "群馬県",
          num: 3
        },
        {
          areaMidCd: "saitama",
          name: "埼玉県",
          num: 4
        },
        {
          areaMidCd: "tiba",
          name: "千葉県",
          num: 4
        },
        {
          areaMidCd: "tokyo",
          name: "東京都",
          num: 4
        },
        {
          areaMidCd: "kanagawa",
          name: "神奈川県",
          num: 4
        }
      ]
    },
    {
      areaLrgCd: 2,
      name: "北陸・信越",
      list: [
        {
          areaMidCd: "niigata",
          name: "新潟県",
          num: 6
        },
        {
          areaMidCd: "yamanasi",
          name: "山梨県",
          num: 6
        },
        {
          areaMidCd: "nagano",
          name: "長野県",
          num: 6
        },
        {
          areaMidCd: "toyama",
          name: "富山県",
          num: 7
        },
        {
          areaMidCd: "ishikawa",
          name: "石川県",
          num: 7
        },
        {
          areaMidCd: "hukui",
          name: "福井県",
          num: 7
        }
      ]
    },
    {
      areaLrgCd: 3,
      name: "東海",
      list: [
        {
          areaMidCd: "gihu",
          name: "岐阜県",
          num: 8
        },
        {
          areaMidCd: "shizuoka",
          name: "静岡県",
          num: 8
        },
        {
          areaMidCd: "aichi",
          name: "愛知県",
          num: 8
        },
        {
          areaMidCd: "mie",
          name: "三重県",
          num: 8
        }
      ]
    },
    {
      areaLrgCd: 4,
      name: "関西",
      list: [
        {
          areaMidCd: "shiga",
          name: "滋賀県",
          num: 9
        },
        {
          areaMidCd: "kyoto",
          name: "京都府",
          num: 9
        },
        {
          areaMidCd: "osaka",
          name: "大阪府",
          num: 9
        },
        {
          areaMidCd: "hyogo",
          name: "兵庫県",
          num: 9
        },
        {
          areaMidCd: "nara",
          name: "奈良県",
          num: 9
        },
        {
          areaMidCd: "wakayama",
          name: "和歌山県",
          num: 9
        }
      ]
    },
    {
      areaLrgCd: 5,
      name: "中国",
      list: [
        {
          areaMidCd: "tottori",
          name: "鳥取県",
          num: 10
        },
        {
          areaMidCd: "simane",
          name: "島根県",
          num: 10
        },
        {
          areaMidCd: "okayama",
          name: "岡山県",
          num: 10
        },
        {
          areaMidCd: "hiroshima",
          name: "広島県",
          num: 10
        },
        {
          areaMidCd: "yamaguchi",
          name: "山口県",
          num: 10
        }
      ]
    },
    {
      areaLrgCd: 6,
      name: "四国",
      list: [
        {
          areaMidCd: "tokushima",
          name: "徳島県",
          num: 11
        },
        {
          areaMidCd: "kagawa",
          name: "香川県",
          num: 11
        },
        {
          areaMidCd: "ehime",
          name: "愛媛県",
          num: 11
        },
        {
          areaMidCd: "kouchi",
          name: "高知県",
          num: 11
        }
      ]
    },
    {
      areaLrgCd: 7,
      name: "九州・沖縄",
      list: [
        {
          areaMidCd: "hukuoka",
          name: "福岡県",
          num: 12
        },
        {
          areaMidCd: "saga",
          name: "佐賀県",
          num: 12
        },
        {
          areaMidCd: "nagasaki",
          name: "長崎県",
          num: 12
        },
        {
          areaMidCd: "kumamoto",
          name: "熊本県",
          num: 12
        },
        {
          areaMidCd: "ooita",
          name: "大分県",
          num: 12
        },
        {
          areaMidCd: "miyazaki",
          name: "宮崎県",
          num: 12
        },
        {
          areaMidCd: "kagoshima",
          name: "鹿児島県",
          num: 12
        },
        {
          areaMidCd: "okinawa",
          name: "沖縄県",
          num: 13
        }
      ]
    }
  ]
};
